<app-dialog-container
  title="{{ (data.isPax ? 'editPassenger' : 'editCrewMember') | translate }}"
  [isValid]="true"
  (confirmButtonHandler)="save()"
  [confirmButtonDisabled]="!isFormValid"
  [confirmButtonText]="'confirm' | translate"
>
  <div class="scroll-container">
    <div class="crew-member-card mb-1">
      <app-user-card [user]="userCardData" [showMenu]="false"></app-user-card>
    </div>
    @if (!data.isPax) {
      <div class="crew-member-contact-info">
        <div>
          <p class="small text-secondary mb-0 mt-0">{{ 'department' | translate | titlecase }}</p>
          <p class="mt-0">{{ data.employmentDepartment?.name }}</p>
        </div>
        <div>
          <p class="small text-secondary mb-0 mt-0">{{ 'phone' | translate | titlecase }}</p>
          <p class="mt-0">{{ data.phoneNumber }}</p>
        </div>
        <div>
          <p class="small text-secondary mb-0 mt-0">{{ 'email' | translate | titlecase }}</p>
          <p class="mt-0">{{ data.email }}</p>
        </div>
      </div>
    }
    @for (position of positions; track position.id; let index = $index) {
      <div class="position-row mb-1">
        @if (positions.length > 1) {
          <div class="position-row-header">
            <span>
              {{ index + 1 }}. {{ (data.isPax ? '' : 'position') | translate | titlecase }}
            </span>
            <mat-icon class="delete-icon cursor-pointer" (click)="deletePosition(index)">
              close
            </mat-icon>
          </div>
        }
        @if (data.hasAssignedWorkSchedules && !data.lastMonthSignedDocumentPeriodDate) {
          <div class="warning-container">
            <span class="warning-text">{{ 'tripBasedEditWorkScheduleWarning' | translate }}</span>
          </div>
        }
        @if (data.hasAssignedWorkSchedules && data.needsDocumentationCompletion) {
          <div class="warning-container">
            <span class="warning-text">
              {{ 'tripBasedEditWorkRestDocumentsNotSignedOffWarning' | translate }}
            </span>
          </div>
        }
        <div class="form-row">
          @if (!data.isPax) {
            <app-ui-select
              label="{{ 'positionOnTheShip' | translate }}"
              [control]="position.position"
              [isMultiple]="false"
              [required]="true"
              [options]="jobPositionsForDepartment()"
            ></app-ui-select>
          }
        </div>
        <div class="form-row">
          <app-shared-ui-datepicker
            *appUseDateTimeFormat
            label="{{ 'startDate' | translate }}"
            description="{{ 'crewMemberStartDate' | translate }}"
            [required]="true"
            [control]="position.from"
          ></app-shared-ui-datepicker>
          <app-shared-ui-datepicker
            *appUseDateTimeFormat
            label="{{ 'endDate' | translate | titlecase }}"
            description="{{ 'crewMemberEndDate' | translate }}"
            [required]="true"
            [control]="position.to"
          ></app-shared-ui-datepicker>
        </div>
        @if (shouldShowReopenedDocumentsWarning(position)) {
          <div class="warning-container">
            <span class="warning-text">
              {{ 'crewMemberDatesReopenedDocumentsOutdatedWarning' | translate }}
            </span>
          </div>
        }
        @if (!data.isPax) {
          <app-ui-text-area
            label="{{ 'comment' | translate }}"
            [control]="position.comment"
          ></app-ui-text-area>
        }
        @if (position.conflictsWith?.length) {
          <div class="error">
            {{ 'dateRangeOverlappingWithOtherPositons' | translate }}
            @for (conflict of position.conflictsWith; track conflict.id) {
              <div>
                {{ conflict.position.value ? positionsNames[conflict.position.value] : '' }}
              </div>
            }
          </div>
        }
      </div>
    }

    <app-ui-button
      class="m-0"
      text="{{ (data.isPax ? 'addDates' : 'addPosition') | translate }}"
      buttonType="secondary"
      (click)="addPosition()"
    ></app-ui-button>
  </div>
</app-dialog-container>
